module.exports = __webpack_public_path__ + "img/qdq.56218082.png";